<template>
	<div class="container">
		<home-header class="header" :title="(topicAllProducts[0] ||{title:'活动'}).title"></home-header>
    <div class="list">
      <home-product-list  v-for="(items,index) in topicAllProducts"  :key="index" :id="items.id" :items="items" :title="items.title" :type="popular" v-if="topicAllProducts && topicAllProducts.length > 0"></home-product-list>
    </div>
		<back-top v-if="isshowBacktop" :target="target" :bottom="60"></back-top>
	</div>
</template>
<script>
import { Header, Indicator, Toast } from 'mint-ui';
import { mapState, mapMutations, mapActions } from 'vuex';
import { HeaderItem } from '../../components/common';
import BackTop from '../../components/common/BackTop';
import HomeHeader from './child/HomeHeader';
import HomeProductList from './child/HomeProductList';
import { ENUM } from '../../const/enum';
import { recommendBonusInfo } from '../../api/recommend'

export default {
  name: 'topic',
  data() {
    return {
      isshowBacktop: false,
      popular: ENUM.SORT_KEY.POPULAR,
      sale: ENUM.SORT_KEY.SALE,
      recently: ENUM.SORT_KEY.DATE,
      shared_link: '',
      page:1,
      topicProducts:[],
      topicAllProducts:[],
    };
  },
  components: {
    HomeHeader,
    HomeProductList,
    BackTop,
  },
  mounted() {         
    var element = this.$el;
    var that = this;
    var dom = document.querySelector('.list');    
    if (dom) {
      dom.addEventListener('scroll', event => {
        let params = {
          top: dom.scrollTop,
          height: dom.scrollHeight
        };
        if (params.top >= 100) {
          this.isshowBacktop = true;
        } else {
          this.isshowBacktop = false;
        }
      });
    }
    this.target = document.querySelector('.list');
    this.getfetchTopicProduct()
  },
  activated(){
    this.target.addEventListener('scroll', (event) => {
      if (this.target.scrollTop) {
        this.offsetTop = this.target.scrollTop
      } 
    });
    if(this.offsetTop) this.target.scrollTop = this.offsetTop
  },
  computed: {
    ...mapState({
      isOnline: state => state.auth.isOnline,
      // topicAllProducts:state => state.topic.topicAllProducts     
    }),
  },
  methods: {
    ...mapActions({
      fetchTopicAllProduct: 'fetchTopicAllProduct',
    }),
    getfetchTopicProduct(){
      Indicator.open();
      let  id = this.$route.query.id || null
      let  display_area = this.$route.query.display_area || 1
      this.fetchTopicAllProduct({topic_id:id,display_area:display_area,page:this.page,per_page:1}).then(
        response => {
          this.topicAllProducts = response.topic
          Indicator.close();
        },
        error => {
          Indicator.close();
        }
      );
    }
  }
};
</script>

<style lang="scss" scoped>
.container {
  height: auto;
  position: absolute;
  bottom: 0px;
  top: 0px;
  width: 100%;
}
.header {
  background-color: #ffffff;
  position: fixed;
  top: 0px;
  left: 0px;
  right: 0px;
  border-bottom: 1px solid $lineColor;
}
// .header :nth-child(1) {
//   background-color: #ffffff;
//   position: fixed;
//   top: 0px;
//   left: 0px;
//   right: 0px;
//   border-bottom: 1px solid $lineColor;
// }
.list {
  background-color: #ffffff;
  padding-top:10px;
  position: absolute;
  top: 32px;
  bottom: 0px;
  overflow-y: auto;
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/page/topic-list/topic.vue